import React from 'react';
import Slider from 'react-slick';
import { __ } from '@wordpress/i18n';
import { decodeEntities } from '@wordpress/html-entities';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/16/solid';
import ICONS from '../icons';
import './style.scss';

const NextArrow = ( props ) => {
	const { className, onClick } = props;
	return (
		<div className={ className } onClick={ onClick }>
			<ChevronRightIcon />
		</div>
	);
};

const PrevArrow = ( props ) => {
	const { className, onClick } = props;
	return (
		<div className={ className } onClick={ onClick }>
			<ChevronLeftIcon />
		</div>
	);
};

const SitesSlider = ( { sites, columns } ) => {
	const settings = {
		dots: false,
		arrows: true,
		speed: 500,
		slidesToShow: columns ? columns : 3,
		slidesToScroll: 1,
		infinite: false,
		autoplay: false,
		autoplaySpeed: 1000,
		nextArrow: <NextArrow />,
		prevArrow: <PrevArrow />,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	};

	return (
		<div className="st-templates-category-slider">
			<Slider { ...settings }>
				{ sites.map( ( site, index ) => {
					return (
						<div className="stc-grid-item" data-id={ site.id } key={ index }>
							<div className="stc-grid-item-inner">
								<div className="stc-grid-item-screenshot-wrap">
									<a href={ site.link } rel="noreferrer">
										<img
											className="stc-grid-site-screenshot"
											src={ site.image }
											alt={ decodeEntities( site.title ) }
											loading="lazy"
										/>
										<div className="stc-grid-item-blur" />
									</a>
								</div>
								<div className="stc-grid-item-header">
									<div
										className="stc-page-builders"
										dangerouslySetInnerHTML={ { __html:
											( site.available_page_builders.includes( 'gutenberg' ) ? ICONS.blockeditor : '' ) +
											( site.available_page_builders.includes( 'elementor' ) ? ICONS.elementor : '' ),
										} } />
									<div className="stc-grid-item-title">
										{ decodeEntities( site.title ) }
										{ site.badge ? (
											<div className="stc-grid-item-badge-wrapper">
												<div className="stc-grid-item-badge">{ site.badge }</div>
												<div className={ `stc-grid-item-badge-tooltip ${ site[ 'astra-sites-type' ] }` }>
													{ site[ 'astra-sites-type' ] === 'signature' ? __( 'Signature', 'astra-sites-showcase' ) : __( 'Premium', 'astra-sites-showcase' ) }
												</div>
											</div>
										) : null }
									</div>
									{ site.desc ? (
										<div className="stc-grid-item-desc">
											{ site.desc.substring( 0, 100 ) }
										</div>
									) : null }
								</div>
								<div className="stc-grid-item-hover-button-wrapper">
									<div className="stc-grid-item-hover-button-wrap">
										<a
											className="stc-grid-item-hover-button"
											href={ site.livelink }
											target="_blank"
											rel="noreferrer"
										>
											{ __(
												'Live Preview',
												'astra-sites-showcase'
											) }
										</a>
									</div>
								</div>
							</div>
						</div>
					);
				} ) }
			</Slider>
		</div>
	);
};

export default SitesSlider;
